import React, {useContext} from 'react';
import { Context } from './Context';
import EvenThree from './mask_types/EvenThree';
import WideThree from './mask_types/WideThree';
import WiderThree from './mask_types/WiderThree';
import EvenFour from './mask_types/EvenFour';
import EvenFive from './mask_types/EvenFive';
import Eclipse from './mask_types/Eclipse';

//image src
import mntView from '../images/masks/mountain-view-golden-hour-photography-733168.jpg';
import eleph from '../images/masks/pexels-photo-247431Pixabay1000.jpeg';
import forest from '../images/masks/trees-in-forest-during-sunset-247421.jpg';

import wolfSrc from '../images/masks/nature-animal-wolf-wildernessPixabay.jpg';
import fishSrc from '../images/masks/pexels-photo-2131828QuangNguyenVinh650.jpeg';
import btrflySrc from '../images/masks/silver-bordered-fritillary-butterfly-nature-orangePixabay.jpg';

import skySrc from '../images/masks/pexels-photo-55787DonaldTong.jpeg';
import nightSrc from '../images/masks/pexels-photo-2885320RobertoNickson.jpeg';
import earthSrc from '../images/masks/earth-spaceJaymantri1000.jpg';


const MaskRadio = () => {
    const { maskTheme, handleRadioSelection } = useContext(Context)
    return (

        <div> 
            <div className="maskContainerSection">
                <div className="maskedImageDisplay _4to3lg">
                    <img src={mntView} alt="mountain landscape at sunrise" />
                    {maskTheme==='even3' && <EvenThree />}
                    {maskTheme==='even4' && <EvenFour />}
                    {maskTheme==='even5' && <EvenFive />}
                    {maskTheme==='wide3' && <WideThree />}
                    {maskTheme==='wider3' && <WiderThree />}
                    <div className="triangle up" style={{display: maskTheme==='triU' ? 'flex' : 'none'}}></div>
                    <div className="triangle down" style={{display: maskTheme==='triD' ? 'flex' : 'none'}}></div>
                </div>
            </div>

            <p className="radioHeader">Image Masks</p>
            <div className="radioBtnContainer">
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="even3" 
                                checked={maskTheme==="even3"} 
                                onChange={handleRadioSelection} />
                    3 panel, even</label>
                </div>
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="even4" 
                                checked={maskTheme==="even4"} 
                                onChange={handleRadioSelection} />
                    4 panel, even</label>
                </div>
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="even5" 
                                checked={maskTheme==="even5"} 
                                onChange={handleRadioSelection} />
                    5 panel, even</label>
                </div>
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="wide3" 
                                checked={maskTheme==="wide3"} 
                                onChange={handleRadioSelection} />
                    3 panel, wide</label>
                </div>
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="wider3" 
                                checked={maskTheme==="wider3"} 
                                onChange={handleRadioSelection} />
                    3 panel, wider</label>
                </div>
                <div>
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="triU" 
                                checked={maskTheme==="triU"} 
                                onChange={handleRadioSelection} />
                    upward triangle</label>
                </div>
                <div className="last">
                    <label>
                        <input type="radio" 
                                name="maskTheme" 
                                value="triD" 
                                checked={maskTheme==="triD"} 
                                onChange={handleRadioSelection} />
                    downward triangle</label>
                </div>
            </div>
                
 
            {/** static masked images */}
            <div className="maskContainerSection">
                <div className="maskContainer _4to3">
                    <img src={mntView} alt="mountain sunrise" />
                    < EvenFour />
                </div>

                <div className="maskContainer _4to3">
                    <img src={eleph} alt="elephant in woods" />
                    < WiderThree />
                </div>

                <div className="maskContainer _4to3">
                    <img src={forest} alt="trees in forest" />
                    < EvenThree />
                </div>
            </div>


            <div className="maskContainerSection">
                <div className="maskContainer _1to1">
                    <img src={wolfSrc} alt="wolf" /> 
                    <div className="triangle down"></div> 
                </div>

                <div className="maskContainer  _1to1lg">
                    <img src={fishSrc} alt="koifish" /> 
                    <div className="triangle up"></div>
                </div>

                <div className="maskContainer _1to1">
                    <img src={btrflySrc} alt="butterfly" />
                    <div className="triangle down"></div>
                </div>
            </div>


            <div className="maskContainerSection">
                <div className="maskContainer _1to1sm">
                    <img className="circle" src={skySrc} alt="sky above couds" />
                </div>

                <div className="maskContainer _1to1lg">
                    <img className="circle" src={nightSrc} alt="night landscape with pine trees" />
                    < Eclipse />
                </div>

                <div className="maskContainer _1to1sm">
                    <img className="circle" src={earthSrc} alt="earth from near space" />
                </div>
            </div>
        </div>
    )
}



export default MaskRadio;